"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});
/**
 * @file Created on Tue Mar 05 2019
 */

var DomainObject_1 = require("../../core/model/DomainObject");
/**
 * @author BPo
 * @author Tomas Leity
 */


var SimulationFindCreateDTO =
/*#__PURE__*/
function (_DomainObject_1$Domai) {
  _inherits(SimulationFindCreateDTO, _DomainObject_1$Domai);

  /**
   * @param promotionId
   * @param simulationId
   * @param sessionId
   * @param conflicts
   * @param lock
   * @param validationResult
   */
  function SimulationFindCreateDTO(promotionId, simulationId, sessionId, conflicts, lock, validationResult) {
    var _this;

    _classCallCheck(this, SimulationFindCreateDTO);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(SimulationFindCreateDTO).call(this));
    _this.promotionId = promotionId;
    _this.simulationId = simulationId;
    _this.sessionId = sessionId;
    _this.conflicts = conflicts;
    _this.lock = lock;
    _this.validationResult = validationResult;
    return _this;
  }

  return SimulationFindCreateDTO;
}(DomainObject_1.DomainObject);

exports.SimulationFindCreateDTO = SimulationFindCreateDTO;